import React, { Component } from "react";
import {
  formDataSchema,
  clearanceFormDataSchema,
} from "../../../schema/tat-report";
import { Table, Tag } from "antd";
import { Select, AutoComplete } from "antd";
import { UndoOutlined } from "@ant-design/icons";
import { Pagination } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import * as R from "ramda";
// import Pagination from "react-js-pagination";
import networkList from "../../../constants/networkList";
import postService from "../../../services/httpService";
import { Switch, Spin, Tooltip, Modal, Button, notification } from "antd";
import DateRange from "../../../components/FormComponent/DateRange";
import Select2 from "../../../components/FormComponent/select2";
import Select2search from "../../../components/FormComponent/select2Search";
import Inputlayer from "../../../components/FormComponent/Input";
import "./tat.css";
const $ = require("jquery");
const { Option } = Select;

const radiologyData = [
  {
    id: 1,
    date: "11-05-2022",
    radiology: "7:00",
    volumes: 5,
    tat: "0:10:00",
  },
  {
    id: 2,
    date: "11-05-2022",
    radiology: "8:00",
    volumes: 6,
    tat: "0:10:00",
  },
  {
    id: 3,
    date: "11-05-2022",
    radiology: "9:00",
    volumes: 7,
    tat: "1:10:00",
  },
  {
    id: 4,
    date: "11-05-2022",
    radiology: "10:00",
    volumes: 8,
    tat: "2:10:00",
  },
  {
    id: 5,
    date: "11-05-2022",
    radiology: "11:00",
    volumes: 9,
    tat: "3:10:00",
  },
  {
    id: 6,
    date: "11-05-2022",
    radiology: "12:00",
    volumes: 10,
    tat: "4:10:00",
  },
];

class TAT_Report extends Component {
  // print = () => {
  //     window.print();
  // }

  csvLink = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      date: "",
      appTime: [],
      headding: null,
      postdata: {},
      formData: [],
      reportData: [],
      reportHead: [],
      reportExcelData: [],
      visible: false,
      dateTo: moment().format("YYYY-MM-DD"),
      dateFrom: moment().subtract(7, "d").format("YYYY-MM-DD"),
      activePage: 1,
      totalItemsCount: 0,
      isLoading: false,
      downloadStatus: 0,
      thead: [],
      tbody: [],
      downloadtbody: [],
      search: "",
      search_key: '',
      filteredData: [],
      filterData: [],
      // showAutoComplete: false,
      showAutoComplete: true,

    };
    this.searchClick = this.searchClick.bind(this);
    const selectedReport = this.state.selectedReport;
  }

  componentDidMount() {
    let { slug } = this.props.match.params;
    let formSchema;
  
    formSchema = Object.assign({}, formDataSchema);
    // formSchema=formSchema.clearanceFormDataSchema;
    formSchema["feilds"].map((feild, key) => {
      formSchema["feilds"][key]["value"] = null;
      formSchema["feilds"][key]["valid"] = false;
      formSchema["feilds"][key]["errors"] = [];

      if (slug === "billing-overall-tat" || slug === "billing-hourly-tat") {
        if (feild["name"] === "billingFilters") {
          feild["value"] = null;
          feild.visible = true;
        }
        if (feild["name"] === "filters") {
          feild["value"] = null;
          feild.visible = false;
        }
      } else {
        if (feild["name"] === "billingFilters") {
          feild["value"] = null;
          feild.visible = false;
        }
        if (feild["name"] === "filters") {
          feild["value"] = null;
          feild.visible = true;
        }
      }
      delete formSchema["feilds"][key]["text"];
    });

    this.setState({ formData: formSchema["feilds"] }, () => {
      this.fetchData(this.state.formData);
      // this.renderHead();
      this.clearFilter();
    });
  }

  itemRender(current, type, originalElement) {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  }

  componentDidUpdate(prevProps, prevState) {
    try {
      let { id, slug } = this.props.match.params;
      let { menuList } = this.props;
      let formSchema;
      let prevSlug = prevProps.match.params.slug;
      if (slug !== prevSlug) {
        menuList.map((menu) => {
          if (slug !== undefined && slug !== null && slug !== "") {
            if (menu["route"] === id) {
              menu["submenu"].map((smenu) => {
                if (smenu["route"] === slug) {
                  this.setState((state) => ({
                    showAdd: JSON.parse(smenu["permissions"]["add"]),
                    showEdit: JSON.parse(smenu["permissions"]["edit"]),
                  }));
                }
              });
            }
          }
        });

        formSchema = Object.assign({}, formDataSchema);
        // formSchema=formSchema.clearanceFormDataSchema;
        formSchema["feilds"].map((feild, key) => {
          formSchema["feilds"][key]["value"] = null;
          formSchema["feilds"][key]["valid"] = false;
          formSchema["feilds"][key]["errors"] = [];
          if (slug === "billing-overall-tat" || slug === "billing-hourly-tat") {
            if (feild["name"] === "billingFilters") {
              feild["value"] = null;
              feild.visible = true;
            }
            if (feild["name"] === "filters") {
              feild["value"] = null;
              feild.visible = false;
            }
          } else {
            if (feild["name"] === "billingFilters") {
              feild["value"] = null;
              feild.visible = false;
            }
            if (feild["name"] === "filters") {
              feild["value"] = null;
              feild.visible = true;
            }
          }
          delete formSchema["feilds"][key]["text"];
        });
        this.setState(
          (state) => ({
            loadding: true,
            dateTo: moment().format("YYYY-MM-DD"),
            activePage: 1,
            totalItemsCount: 0,
            dateFrom: moment().subtract(7, "d").format("YYYY-MM-DD"),
            formData: formSchema["feilds"],
          }),
          () => {
            this.clearFilter();
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentWillUnmount() {
    $("footer").css({ position: "relative", top: "unset" });
    this.setState({ formData: [] });
  }

  fetchData(fetchData) {
    var payload = {
      unit_id: null,
      from_date: this.state.dateFrom,
      to_date: this.state.dateTo,
      page: this.state.activePage,
    };
  
  }

  stageProcess(stage) {
    let statge_name = null;
    switch (stage) {
      case "1":
        statge_name = "Tentative";
        break;
      case "2":
        statge_name = "Confirm";
        break;
      case "3":
        statge_name = "Wheel IN";
        break;
      case "4":
        statge_name = "Wheel Out";
        break;
      case "5":
        statge_name = "Delayed";
        break;
      default:
        break;
    }

    return statge_name;
  }

  loadPage = (search_key, isDatefilter = false) => {
    try {
      let { activePage, search_key } = this.state;
      let { slug } = this.props.match.params;
    
      const {
        getTatReport,
        getOverallTatReportsByDepartment,
        getHourlyTatReportsByDepartment,
        getOverallBillingTATReport,
        getHourlyBillingTATReport,
      } = networkList;
      let tableHead = [];
      let data = [];
      let This = this;
      let userData = localStorage.getItem("user_data");
      if (userData !== undefined && userData !== null && userData !== "") {
        userData = JSON.parse(userData);
      }
      this.setState({ downloadStatus: 0 });

      // let data = {
      //     "from": this.state.dateFrom,
      //     "to": this.state.dateTo
      // }
      // console.log('data:', data)

      switch (slug) {
        case "billing-overall-tat":
          tableHead = [
            { key: "patient_name", label: "Patient Name" },
            { key: "umr", label: "UMR" },
            { key: "billnumber", label: "Bill Number" },
            { key: "casetype", label: "Patient Type" },
            { key: "unit_name", label: "Unit Name" },
            { key: "age", label: "Age" },
            { key: "gender", label: "Gender" },
            { key: "phone_number", label: "Phone Number" },
            { key: "appointment_date", label: "Appointment Date" },
            { key: "appointment_id", label: "Appointment Id" },
            { key: "departmentname", label: "Department" },
            { key: "service_group_name", label: "Service Group" },
            { key: "service_name", label: "Service Name" },
            {
              key: "room_number",
              label: "Room Number",
            },
            { key: "arrivaltime", label: "Arrival Time" },
            { key: "vitals_time", label: "Vitals Time" },
            { key: "checkin_time", label: "Checkin Time" },
            { key: "checkout_time", label: "Checkout Time" },
            { key: "WaitingTAT", label: "Waiting TAT" },
            { key: "ProceduralTAT", label: "Procedural TAT" },
            { key: "billing_time", label: "Billing Time" },
            { key: "bill_done_by", label: "Bill Done By" },
            { key: "bill_cancel_status", label: "Bill Cancel Status" },
            { key: "bill_cancel_date", label: "Bill Cancel Date" },
            { key: "created_at", label: "Created At" },
            { key: "doctor_name", label: "Doctor Name" },
            {
              key: "latest_skip_reason",
              label: "Latest Skip Reason",
            },
          ];
          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Billing Overall TAT",
              thead: tableHead,
              filename: "billing-overall-tat",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
              

              // let payload = {
              //   from: moment(this.state.dateFrom).format("YYYY-MM-DD"),
              //   to: moment(this.state.dateTo).format("YYYY-MM-DD"),
              //   export: 0,
              //   page_no: isDatefilter ? 1 : activePage,
              //   unit_id: userData
              //     ? userData["unitid"]
              //       ? userData["unitid"]
              //       : null
              //     : null,
              //   block_id: "",
              //   floor_id: "",
              //   ot_id: "",
              //   doctor_id: "",
              // };

              let payload = {
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                filter: null,
                page: activePage,
                export: 0,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "",
              };
              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else if (
                  (data["name"] === "billingFilters" && data["visible"]) ||
                  (data["name"] === "filters" && data["visible"])
                ) {
                  payload["filters"] = data["value"] ? data["value"] : "";
                } else {
                  if (data["name"] !== "billingFilters" || data["name"] !== "filters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//ic
              postService(getOverallBillingTATReport, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  res.data.map((data, key) => {
                    Object.keys(data).map((dataKey) => {
                      if (dataKey === "is_delayed") {
                        res.data[key]["slot_extended"] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (
                        dataKey === "is_rescheduled" ||
                        dataKey === "is_cancelled"
                      ) {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (dataKey === "current_workflow_stage") {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? this.stageProcess(res.data[key][dataKey])
                          : null;
                      }
                    });
                  });
                  this.setState((state) => ({
                    tbody: res.data,
                    totalItemsCount: res.total_items,
                    data: data,
                    loadding: false,
                  }));
                  // enable downloadbtn after 2sec
                  setTimeout(function () {
                    This.setState((state) => ({
                      downloadStatus: 1,
                      loadding: false,
                    }));
                  }, 2000);
                } else {
                  if (res === 401) {
                    This.setState((state) => ({ loadding: false }));
                  } else {
                    This.setState((state) => ({ loadding: false }));
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        case "radiology-overall-tat":
          tableHead = [
            { key: "name", label: "Patient Name" },
            { key: "umr", label: "UMR" },
            { key: "billnumber", label: "Bill Number" },
            { key: "casetype", label: "Patient Type" },
            { key: "unitname", label: "Unit Name" },
            { key: "age", label: "Age" },
            { key: "gender", label: "Gender" },
            { key: "phonenumber", label: "Phone Number" },
            { key: "appointment_date", label: "Appointment Date" },
            { key: "appointment_id", label: "Appointment Id" },
            { key: "departmentname", label: "Department" },
            { key: "service_group_name", label: "Service Group" },
            { key: "service_name", label: "Service Name" },
            {
              key: "room_number",
              label: "Room Number",
            },
            { key: "arrivaltime", label: "Arrival Time" },
            { key: "vitals_time", label: "Vitals Time" },
            { key: "checkin_time", label: "Checkin Time" },
            { key: "checkout_time", label: "Checkout Time" },
            { key: "WaitingTAT1", label: "Waiting TAT1" },
            { key: "WaitingTAT2", label: "Waiting TAT2" },
            { key: "ProceduralTAT", label: "Procedural TAT" },
            { key: "billing_time", label: "Billing Time" },
            { key: "bill_done_by", label: "Bill Done By" },
            { key: "bill_cancel_status", label: "Bill Cancel Status" },
            { key: "bill_cancel_date", label: "Bill Cancel Date" },
            { key: "created_at", label: "Created At" },
            { key: "doctor_name", label: "Doctor Name" },
            {
              key: "latest_skip_reason",
              label: "Latest Skip Reason",
            },
          ];

          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Radiology Overall TAT",
              thead: tableHead,
              filename: "radiology-overall-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
            

              // let payload = {
              //   from: moment(this.state.dateFrom).format("YYYY-MM-DD"),
              //   to: moment(this.state.dateTo).format("YYYY-MM-DD"),
              //   export: 0,
              //   page_no: isDatefilter ? 1 : activePage,
              //   unit_id: userData
              //     ? userData["unitid"]
              //       ? userData["unitid"]
              //       : null
              //     : null,
              //   block_id: "",
              //   floor_id: "",
              //   ot_id: "",
              //   doctor_id: "",
              // };

              let payload = {
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                filter: null,
                page: activePage,
                export: 0,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "Radiology",
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else if (
                  (data["name"] === "billingFilters" && data["visible"]) ||
                  (data["name"] === "filters" && data["visible"])
                ) {
                  payload["filters"] = data["value"] ? data["value"] : "";
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//cc
              postService(getOverallTatReportsByDepartment, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  res.data.map((data, key) => {
                    Object.keys(data).map((dataKey) => {
                      if (dataKey === "is_delayed") {
                        res.data[key]["slot_extended"] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (
                        dataKey === "is_rescheduled" ||
                        dataKey === "is_cancelled"
                      ) {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (dataKey === "current_workflow_stage") {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? this.stageProcess(res.data[key][dataKey])
                          : null;
                      }
                    });
                  });
                  this.setState((state) => ({
                    tbody: res.data,
                    totalItemsCount: res.total_items,
                    data: data,
                    loadding: false,
                  }));
                  // enable downloadbtn after 2sec
                  setTimeout(function () {
                    This.setState((state) => ({
                      downloadStatus: 1,
                      loadding: false,
                    }));
                  }, 2000);
                } else {
                  if (res === 401) {
                    This.setState((state) => ({ loadding: false }));
                  } else {
                    This.setState((state) => ({ loadding: false }));
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        case "consulting-overall-tat":
          tableHead = [
            { key: "name", label: "Patient Name" },
            { key: "umr", label: "UMR" },
            { key: "billnumber", label: "Bill Number" },
            { key: "casetype", label: "Patient Type" },
            { key: "unitname", label: "Unit Name" },
            { key: "age", label: "Age" },
            { key: "gender", label: "Gender" },
            { key: "phonenumber", label: "Phone Number" },
            { key: "appointment_date", label: "Appointment Date" },
            { key: "appointment_id", label: "Appointment Id" },
            { key: "departmentname", label: "Department" },
            { key: "service_group_name", label: "Service Group" },
            { key: "service_name", label: "Service Name" },
            {
              key: "room_number",
              label: "Room Number",
            },
            { key: "arrivaltime", label: "Arrival Time" },
            { key: "vitals_time", label: "Vitals Time" },
            { key: "checkin_time", label: "Checkin Time" },
            { key: "checkout_time", label: "Checkout Time" },
            { key: "WaitingTAT1", label: "Waiting TAT 1" },
            { key: "WaitingTAT2", label: "Waiting TAT 2" },
            { key: "ProceduralTAT", label: "Procedural TAT" },
            { key: "billing_time", label: "Billing Time" },
            { key: "bill_done_by", label: "Bill Done By" },
            { key: "bill_cancel_status", label: "Bill Cancel Status" },
            { key: "bill_cancel_date", label: "Bill Cancel Date" },
            { key: "created_at", label: "Created At" },
            { key: "service_name", label: "Billed_Doctor" },
            { key: "served_doctor_name", label: "Served_Doctor" },
            {
              key: "latest_skip_reason",
              label: "Latest Skip Reason",
            },
          ];

          this.setState(
            (state) => ({
              showFilter: search_key ? true : false,
              tableTitle: "Consulting Overall TAT",
              thead: tableHead,
              filename: "consulting-overall-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: true,
            }),
            () => {
          

              // let payload = {
              //   from: moment(this.state.dateFrom).format("YYYY-MM-DD"),
              //   to: moment(this.state.dateTo).format("YYYY-MM-DD"),
              //   export: 0,
              //   page_no: isDatefilter ? 1 : activePage,
              //   unit_id: userData
              //     ? userData["unitid"]
              //       ? userData["unitid"]
              //       : null
              //     : null,
              //   block_id: "",
              //   floor_id: "",
              //   ot_id: "",
              //   doctor_id: "",
              // };

              let payload = {
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                filter: null,
                page: activePage,
                export: 0,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "OPD Consultation",
                search_key: search_key ? search_key : '',
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] =
                    userData && userData["unitid"] ? userData["unitid"] : null;
                } else if (
                  (data["name"] === "billingFilters" && data["visible"]) ||
                  (data["name"] === "filters" && data["visible"])
                ) {
                  payload["filters"] = data["value"] ? data["value"] : "";
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//cc
              postService(getOverallTatReportsByDepartment, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  res.data.map((data, key) => {
                    Object.keys(data).map((dataKey) => {
                      if (dataKey === "is_delayed") {
                        res.data[key]["slot_extended"] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (
                        dataKey === "is_rescheduled" ||
                        dataKey === "is_cancelled"
                      ) {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (dataKey === "current_workflow_stage") {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? this.stageProcess(res.data[key][dataKey])
                          : null;
                      }
                    });
                  });
                  this.setState((state) => ({
                    tbody: res.data,
                    totalItemsCount: res.total_items,
                    data: data,
                    loadding: false,
                  }));
                  // enable downloadbtn after 2sec
                  setTimeout(function () {
                    This.setState((state) => ({
                      downloadStatus: 1,
                      loadding: false,
                    }));
                  }, 2000);
                } else {
                  if (res === 401) {
                    This.setState((state) => ({ loadding: false }));
                  } else {
                    This.setState((state) => ({ loadding: false }));
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );
          break;
        case "radiology-hourly-tat":
          tableHead = [
            { key: "created_date", label: "Date" },
            { key: "created_hour", label: "Hour" },
            { key: "count", label: "VOLUMES" },
            { key: "avg_tat", label: "TAT" },
          ];
          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Radiology Hourly TAT",
              thead: tableHead,
              filename: "radiology-hourly-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
          

              // let payload = {
              //   from: moment(this.state.dateFrom).format("YYYY-MM-DD"),
              //   to: moment(this.state.dateTo).format("YYYY-MM-DD"),
              //   export: 0,
              //   page_no: isDatefilter ? 1 : activePage,
              //   unit_id: userData
              //     ? userData["unitid"]
              //       ? userData["unitid"]
              //       : null
              //     : null,
              //   block_id: "",
              //   floor_id: "",
              //   ot_id: "",
              //   doctor_id: "",
              // };

              let payload = {
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                filter: null,
                page: activePage,
                export: 0,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "Radiology",
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else if (
                  (data["name"] === "billingFilters" && data["visible"]) ||
                  (data["name"] === "filters" && data["visible"])
                ) {
                  payload["filters"] = data["value"] ? data["value"] : "";
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
              //cc
              postService(getHourlyTatReportsByDepartment, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  res.data.map((data, key) => {
                    Object.keys(data).map((dataKey) => {
                      if (dataKey === "is_delayed") {
                        res.data[key]["slot_extended"] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (
                        dataKey === "is_rescheduled" ||
                        dataKey === "is_cancelled"
                      ) {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (dataKey === "current_workflow_stage") {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? this.stageProcess(res.data[key][dataKey])
                          : null;
                      }
                    });
                  });
                  this.setState((state) => ({
                    tbody: res.data,
                    totalItemsCount: res.total_items,
                    data: data,
                    loadding: false,
                  }));
                  // enable downloadbtn after 2sec
                  setTimeout(function () {
                    This.setState((state) => ({
                      downloadStatus: 1,
                      loadding: false,
                    }));
                  }, 2000);
                } else {
                  if (res === 401) {
                    This.setState((state) => ({ loadding: false }));
                  } else {
                    This.setState((state) => ({ loadding: false }));
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        case "billing-hourly-tat":
          tableHead = [
            { key: "created_date", label: "Date" },
            { key: "created_hour", label: "Hour" },
            { key: "count", label: "VOLUMES" },
            { key: "avg_tat", label: "TAT" },
          ];

          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Billing Hourly TAT",
              thead: tableHead,
              filename: "billing-hourly-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
          

              // let payload = {
              //   from: moment(this.state.dateFrom).format("YYYY-MM-DD"),
              //   to: moment(this.state.dateTo).format("YYYY-MM-DD"),
              //   export: 0,
              //   page_no: isDatefilter ? 1 : activePage,
              //   unit_id: userData
              //     ? userData["unitid"]
              //       ? userData["unitid"]
              //       : null
              //     : null,
              //   block_id: "",
              //   floor_id: "",
              //   ot_id: "",
              //   doctor_id: "",
              // };

              let payload = {
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                filter: null,
                page: activePage,
                export: 0,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "",
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else if (
                  (data["name"] === "billingFilters" && data["visible"]) ||
                  (data["name"] === "filters" && data["visible"])
                ) {
                  payload["filters"] = data["value"] ? data["value"] : "";
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//ic
              postService(getHourlyBillingTATReport, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  res.data.map((data, key) => {
                    Object.keys(data).map((dataKey) => {
                      if (dataKey === "is_delayed") {
                        res.data[key]["slot_extended"] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (
                        dataKey === "is_rescheduled" ||
                        dataKey === "is_cancelled"
                      ) {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (dataKey === "current_workflow_stage") {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? this.stageProcess(res.data[key][dataKey])
                          : null;
                      }
                    });
                  });
                  this.setState((state) => ({
                    tbody: res.data,
                    totalItemsCount: res.total_items,
                    data: data,
                    loadding: false,
                  }));
                  // enable downloadbtn after 2sec
                  setTimeout(function () {
                    This.setState((state) => ({
                      downloadStatus: 1,
                      loadding: false,
                    }));
                  }, 2000);
                } else {
                  if (res === 401) {
                    This.setState((state) => ({ loadding: false }));
                  } else {
                    This.setState((state) => ({ loadding: false }));
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        case "consulting-hourly-tat":
          tableHead = [
            { key: "created_date", label: "Date" },
            { key: "created_hour", label: "Hour" },
            { key: "count", label: "VOLUMES" },
            { key: "avg_tat", label: "Avg TAT" },
          ];

          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Consulting Hourly TAT",
              thead: tableHead,
              filename: "consulting-hourly-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
           

              // let payload = {
              //   from: moment(this.state.dateFrom).format("YYYY-MM-DD"),
              //   to: moment(this.state.dateTo).format("YYYY-MM-DD"),
              //   export: 0,
              //   page_no: isDatefilter ? 1 : activePage,
              //   unit_id: userData
              //     ? userData["unitid"]
              //       ? userData["unitid"]
              //       : null
              //     : null,
              //   block_id: "",
              //   floor_id: "",
              //   ot_id: "",
              //   doctor_id: "",
              // };

              let payload = {
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                filter: null,
                page: activePage,
                export: 0,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "OPD Consultation",
              };
console.log("Consulting Hourly",payload,this.state.dateFrom,this.state.dateTo);
              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else if (
                  (data["name"] === "billingFilters" && data["visible"]) ||
                  (data["name"] === "filters" && data["visible"])
                ) {
                  payload["filters"] = data["value"] ? data["value"] : "";
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//cc
              postService(getHourlyTatReportsByDepartment, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  res.data.map((data, key) => {
                    Object.keys(data).map((dataKey) => {
                      if (dataKey === "is_delayed") {
                        res.data[key]["slot_extended"] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (
                        dataKey === "is_rescheduled" ||
                        dataKey === "is_cancelled"
                      ) {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? "Yes"
                          : null;
                      }

                      if (dataKey === "current_workflow_stage") {
                        res.data[key][dataKey] = res.data[key][dataKey]
                          ? this.stageProcess(res.data[key][dataKey])
                          : null;
                      }
                    });
                  });
                  // data with UI pagination
                  let paginationData = []
                  if (res.data.length) {
                    paginationData = res["data"].slice((activePage - 1) * 20, activePage * 20)
                  }

                  this.setState((state) => ({
                    // tbody: res.data,
                    tbody: paginationData,
                    totalItemsCount: res.total_items,
                    data: data,
                    loadding: false,
                  }));
                  // enable downloadbtn after 2sec
                  setTimeout(function () {
                    This.setState((state) => ({
                      downloadStatus: 1,
                      loadding: false,
                    }));
                  }, 2000);
                } else {
                  if (res === 401) {
                    This.setState((state) => ({ loadding: false }));
                  } else {
                    This.setState((state) => ({ loadding: false }));
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  };
  handleChange(ele) {
  
    var formFeilds = this.state.formData;
    // console.log('formFeilds:',formFeilds[2].value)
    // console.log('formFeilds 1:',formFeilds[1].value)
    // this.setState(({
    //     activePage: 1,
    //     totalItemsCount: 0, doctor_id: formFeilds[0].value, payment_type: parseInt(formFeilds[1].value), searchwords: formFeilds[2].value
    // }), () => {
    //     this.loadPage()
    // })
    if (ele) {
      formFeilds.map((data, key) => {
        if (data.name === ele.name) {
          formFeilds[key]["value"] = ele.value;
          formFeilds[key]["label"] = ele.label;
        }
        data.rules.map((rule, ruleKey) => {
          if (rule.test && rule.type == "disabled") {
            formFeilds[key]["disabled"] = rule.test();
          }
          if (rule.test && rule.type == "change_event" && rule.test(ele)) {
            formFeilds[key]["value"] = null;
            formFeilds[key]["label"] = null;
          }
        });
      });
    }

    this.setState({ formFeilds: formFeilds, activePage: 1, });
  }
  handlePageChange(page) {
   
    this.setState(
      (state) => ({
        tbody: [],
        activePage: page,
        formFeilds: this.state.formFeilds
      }),
      () => {
        this.loadPage();
      }
    );
  }
  search = () => {
    // let {search}=this.state
    this.setState(
      (state) => ({
        activePage: 1,
        totalItemsCount: 0,
      }),
      () => {
        this.loadPage();
      }
    );
  };
  dateRange = () => {
    this.setState(
      (state) => ({
        activePage: 1,
        totalItemsCount: 0,
        tbody: [],
      }),
      () => {
        
        this.loadPage(true);
      }
    );
  };
  downloadFile = (isDatefilter = false) => {
    try {
      let { activePage } = this.state;
      let { slug } = this.props.match.params;
      const {
        getTatReport,
        getOverallTatReportsByDepartment,
        getHourlyTatReportsByDepartment,
        getOverallBillingTATReport,
        getHourlyBillingTATReport,
      } = networkList;
      let tableHead = [];
      let data = [];
      let This = this;
      let userData = localStorage.getItem("user_data");
      if (userData !== undefined && userData !== null && userData !== "") {
        userData = JSON.parse(userData);
      }

      switch (slug) {
        case "radiology-overall-tat":
          tableHead = [
            { key: "name", label: "Patient Name" },
            { key: "umr", label: "UMR" },
            { key: "billnumber", label: "Bill Number" },
            { key: "casetype", label: "Patient Type" },
            { key: "unitname", label: "Unit Name" },
            { key: "age", label: "Age" },
            { key: "gender", label: "Gender" },
            { key: "phonenumber", label: "Phone Number" },
            { key: "appointment_date", label: "Appointment Date" },
            { key: "appointment_id", label: "Appointment Id" },
            { key: "departmentname", label: "Department" },
            { key: "service_group_name", label: "Service Group" },
            { key: "service_name", label: "Service Name" },
            {
              key: "room_number",
              label: "Room Number",
            },
            { key: "arrivaltime", label: "Arrival Time" },
            { key: "vitals_time", label: "Vitals Time" },
            { key: "checkin_time", label: "Checkin Time" },
            { key: "checkout_time", label: "Checkout Time" },
            { key: "WaitingTAT1", label: "Waiting TAT 1" },
            { key: "WaitingTAT2", label: "Waiting TAT 2" },
            { key: "ProceduralTAT", label: "Procedural TAT" },
            { key: "billing_time", label: "Billing Time" },
            { key: "bill_done_by", label: "Bill Done By" },
            { key: "bill_cancel_status", label: "Bill Cancel Status" },
            { key: "bill_cancel_date", label: "Bill Cancel Date" },
            { key: "created_at", label: "Created At" },
            { key: "doctor_name", label: "Doctor Name" },
            {
              key: "latest_skip_reason",
              label: "Latest Skip Reason",
            },
          ];

          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Radiology Overall TAT",
              thead: tableHead,
              filename: "radiology-overall-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
              let payload = {
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                filter: null,
                page: activePage,
                export: 1,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "Radiology",
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//cc
              postService(getOverallTatReportsByDepartment, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                
                  // res.data.map((data, key) => {
                  //   Object.keys(data).map((dataKey) => {
                  //     if (dataKey === "is_delayed") {
                  //       res.data[key]["slot_extended"] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (
                  //       dataKey === "is_rescheduled" ||
                  //       dataKey === "is_cancelled"
                  //     ) {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (dataKey === "current_workflow_stage") {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? this.stageProcess(res.data[key][dataKey])
                  //         : null;
                  //     } else {
                  //       res.data[key][dataKey] =
                  //         (res.data[key][dataKey] &&
                  //           res.data[key][dataKey] !== "--") ||
                  //         res.data[key][dataKey] == 0
                  //           ? res.data[key][dataKey]
                  //           : "NA";
                  //     }
                  //   });
                  // });
                  This.setState((state) => ({
                    downloadStatus: 1,
                    downloadtbody: res.data,
                    loadding: false,
                  }));
                  this.csvLink.current.link.click();
                } else {
                  if (res === 401) {
                  } else {
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        case "billing-overall-tat":
          tableHead = [
            { key: "patient_name", label: "Patient Name" },
            { key: "umr", label: "UMR" },
            { key: "billnumber", label: "Bill Number" },
            { key: "casetype", label: "Patient Type" },
            { key: "unit_name", label: "Unit Name" },
            { key: "age", label: "Age" },
            { key: "gender", label: "Gender" },
            { key: "phone_number", label: "Phone Number" },
            { key: "appointment_date", label: "Appointment Date" },
            { key: "appointment_id", label: "Appointment Id" },
            { key: "departmentname", label: "Department" },
            { key: "service_group_name", label: "Service Group" },
            { key: "service_name", label: "Service Name" },
            {
              key: "room_number",
              label: "Room Number",
            },
            { key: "arrivaltime", label: "Arrival Time" },
            { key: "vitals_time", label: "Vitals Time" },
            { key: "checkin_time", label: "Checkin Time" },
            { key: "checkout_time", label: "Checkout Time" },
            { key: "WaitingTAT1", label: "Waiting TAT 1" },
            { key: "WaitingTAT2", label: "Waiting TAT 2" },
            { key: "ProceduralTAT", label: "Procedural TAT" },
            { key: "billing_time", label: "Billing Time" },
            { key: "bill_done_by", label: "Bill Done By" },
            { key: "bill_cancel_status", label: "Bill Cancel Status" },
            { key: "bill_cancel_date", label: "Bill Cancel Date" },
            { key: "created_at", label: "Created At" },
            { key: "doctor_name", label: "Doctor Name" },
            {
              key: "latest_skip_reason",
              label: "Latest Skip Reason",
            },
          ];

          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Billing Overall TAT",
              thead: tableHead,
              filename: "billing-overall-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
           
              let payload = {
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                filter: null,
                page: activePage,
                export: 1,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "",
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//ic
              postService(getOverallBillingTATReport, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
               
                  // res.data.map((data, key) => {
                  //   Object.keys(data).map((dataKey) => {
                  //     if (dataKey === "is_delayed") {
                  //       res.data[key]["slot_extended"] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (
                  //       dataKey === "is_rescheduled" ||
                  //       dataKey === "is_cancelled"
                  //     ) {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (dataKey === "current_workflow_stage") {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? this.stageProcess(res.data[key][dataKey])
                  //         : null;
                  //     } else {
                  //       res.data[key][dataKey] =
                  //         (res.data[key][dataKey] &&
                  //           res.data[key][dataKey] !== "--") ||
                  //         res.data[key][dataKey] == 0
                  //           ? res.data[key][dataKey]
                  //           : "NA";
                  //     }
                  //   });
                  // });
                  This.setState((state) => ({
                    downloadStatus: 1,
                    downloadtbody: res.data,
                    loadding: false,
                  }));
                  this.csvLink.current.link.click();
                } else {
                  if (res === 401) {
                  } else {
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );
          break;
        case "consulting-overall-tat":
          tableHead = [
            { key: "name", label: "Patient Name" },
            { key: "umr", label: "UMR" },
            { key: "billnumber", label: "Bill Number" },
            { key: "casetype", label: "Patient Type" },
            { key: "unitname", label: "Unit Name" },
            { key: "age", label: "Age" },
            { key: "gender", label: "Gender" },
            { key: "phonenumber", label: "Phone Number" },
            { key: "appointment_date", label: "Appointment Date" },
            { key: "appointment_id", label: "Appointment Id" },
            { key: "departmentname", label: "Department" },
            { key: "service_group_name", label: "Service Group" },
            { key: "service_name", label: "Service Name" },
            {
              key: "room_number",
              label: "Room Number",
            },
            { key: "arrivaltime", label: "Arrival Time" },
            { key: "vitals_time", label: "Vitals Time" },
            { key: "checkin_time", label: "Checkin Time" },
            { key: "checkout_time", label: "Checkout Time" },
            { key: "WaitingTAT1", label: "Waiting TAT 1" },
            { key: "WaitingTAT2", label: "Waiting TAT 2" },
            { key: "ProceduralTAT", label: "Procedural TAT" },
            { key: "billing_time", label: "Billing Time" },
            { key: "bill_done_by", label: "Bill Done By" },
            { key: "bill_cancel_status", label: "Bill Cancel Status" },
            { key: "bill_cancel_date", label: "Bill Cancel Date" },
            { key: "created_at", label: "Created At" },
            { key: "service_name", label: "Billed_Doctor" },
            { key: "served_doctor_name", label: "Served_Doctor" },
            {
              key: "latest_skip_reason",
              label: "Latest Skip Reason",
            },
          ];

          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Consulting Overall TAT",
              thead: tableHead,
              filename: "consulting-overall-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: true,
            }),
            () => {
              let payload = {
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                filter: null,
                page: activePage,
                export: 1,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "OPD Consultation",
              };
console.log("Consulting Overall OPDSATSAT",payload,this.state.dateFrom,this.state.dateTo);
              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//cc
              postService(getOverallTatReportsByDepartment, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  // res.data.map((data, key) => {
                  //   Object.keys(data).map((dataKey) => {
                  //     if (dataKey === "is_delayed") {
                  //       res.data[key]["slot_extended"] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (
                  //       dataKey === "is_rescheduled" ||
                  //       dataKey === "is_cancelled"
                  //     ) {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (dataKey === "current_workflow_stage") {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? this.stageProcess(res.data[key][dataKey])
                  //         : null;
                  //     } else {
                  //       res.data[key][dataKey] =
                  //         (res.data[key][dataKey] &&
                  //           res.data[key][dataKey] !== "--") ||
                  //         res.data[key][dataKey] == 0
                  //           ? res.data[key][dataKey]
                  //           : "NA";
                  //     }
                  //   });
                  // });
                  This.setState((state) => ({
                    downloadStatus: 1,
                    downloadtbody: res.data,
                    loadding: false,
                  }));
                  this.csvLink.current.link.click();
                } else {
                  if (res === 401) {
                  } else {
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        case "radiology-hourly-tat":
          tableHead = [
            { key: "created_date", label: "Date" },
            { key: "created_hour", label: "Hour" },
            { key: "count", label: "VOLUMES" },
            { key: "avg_tat", label: "TAT" },
          ];

          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Radiology Hourly TAT",
              thead: tableHead,
              filename: "radiology-hourly-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
              let payload = {
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                filter: null,
                page: activePage,
                export: 1,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "Radiology",
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//cc
              postService(getHourlyTatReportsByDepartment, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  // res.data.map((data, key) => {
                  //   Object.keys(data).map((dataKey) => {
                  //     if (dataKey === "is_delayed") {
                  //       res.data[key]["slot_extended"] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (
                  //       dataKey === "is_rescheduled" ||
                  //       dataKey === "is_cancelled"
                  //     ) {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (dataKey === "current_workflow_stage") {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? this.stageProcess(res.data[key][dataKey])
                  //         : null;
                  //     } else {
                  //       res.data[key][dataKey] =
                  //         (res.data[key][dataKey] &&
                  //           res.data[key][dataKey] !== "--") ||
                  //         res.data[key][dataKey] == 0
                  //           ? res.data[key][dataKey]
                  //           : "NA";
                  //     }
                  //   });
                  // });
                  This.setState((state) => ({
                    downloadStatus: 1,
                    downloadtbody: res.data,
                    loadding: false,
                  }));
                  this.csvLink.current.link.click();
                } else {
                  if (res === 401) {
                  } else {
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        case "billing-hourly-tat":
          tableHead = [
            { key: "created_date", label: "Date" },
            { key: "created_hour", label: "Hour" },
            { key: "count", label: "VOLUMES" },
            { key: "avg_tat", label: "TAT" },
          ];

          this.setState(
            (state) => ({
              showFilter: false,
              tableTitle: "Billing Hourly TAT   ",
              thead: tableHead,
              filename: "billing-hourly-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
              let payload = {
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                filter: null,
                page: activePage,
                export: 1,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "",
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//ic
              postService(getHourlyBillingTATReport, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                  // res.data.map((data, key) => {
                  //   Object.keys(data).map((dataKey) => {
                  //     if (dataKey === "is_delayed") {
                  //       res.data[key]["slot_extended"] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (
                  //       dataKey === "is_rescheduled" ||
                  //       dataKey === "is_cancelled"
                  //     ) {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (dataKey === "current_workflow_stage") {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? this.stageProcess(res.data[key][dataKey])
                  //         : null;
                  //     } else {
                  //       res.data[key][dataKey] =
                  //         (res.data[key][dataKey] &&
                  //           res.data[key][dataKey] !== "--") ||
                  //         res.data[key][dataKey] == 0
                  //           ? res.data[key][dataKey]
                  //           : "NA";
                  //     }
                  //   });
                  // });
                  This.setState((state) => ({
                    downloadStatus: 1,
                    downloadtbody: res.data,
                    loadding: false,
                  }));
                  this.csvLink.current.link.click();
                } else {
                  if (res === 401) {
                  } else {
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        case "consulting-hourly-tat":
          tableHead = [
            { key: "created_date", label: "Date" },
            { key: "created_hour", label: "Hour" },
            { key: "count", label: "VOLUMES" },
            { key: "avg_tat", label: "Avg TAT" },
          ];
          this.setState(
            (state) => ({
              showFilter: true,
              tableTitle: "Consulting Hourly TAT",
              thead: tableHead,
              filename: "consulting-hourly-tat.csv",
              loadding: true,
              download_btn: true,
              select2: true,
              search: false,
              showAutoComplete: false,
            }),
            () => {
              let payload = {
                from_date: moment(this.state.dateFrom).format("YYYY-MM-DD"),
                to_date: moment(this.state.dateTo).format("YYYY-MM-DD"),
                unit_id: userData
                  ? userData["unitid"]
                    ? userData["unitid"]
                    : null
                  : null,
                department_id: null,
                service_group_id: null,
                service_id: null,
                filter: null,
                page: activePage,
                export: 1,
                filters: "",
                date: "",
                patient_type: this.state.formData[0].value,
                report_type: "OPD Consultation",
              };

              var formFeilds = this.state.formData;

              formFeilds.map((data) => {
                if (data["name"] === "unit_id") {
                  payload[data["unit_id"]] = userData
                    ? userData["unitid"]
                      ? userData["unitid"]
                      : null
                    : null;
                } else {
                  if (data["name"] !== "billingFilters") {
                    payload[data["name"]] = data["value"] ? data["value"] : "";
                  }
                }
              });
//cc
              postService(getHourlyTatReportsByDepartment, "POST", {
                data: payload,
              }).then((res) => {
                if (res.status) {
                 // res.data.map((data, key) => {
                  //   Object.keys(data).map((dataKey) => {
                  //     if (dataKey === "is_delayed") {
                  //       res.data[key]["slot_extended"] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (
                  //       dataKey === "is_rescheduled" ||
                  //       dataKey === "is_cancelled"
                  //     ) {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? "Yes"
                  //         : null;
                  //     }

                  //     if (dataKey === "current_workflow_stage") {
                  //       res.data[key][dataKey] = res.data[key][dataKey]
                  //         ? this.stageProcess(res.data[key][dataKey])
                  //         : null;
                  //     } else {
                  //       res.data[key][dataKey] =
                  //         (res.data[key][dataKey] &&
                  //           res.data[key][dataKey] !== "--") ||
                  //         res.data[key][dataKey] == 0
                  //           ? res.data[key][dataKey]
                  //           : "NA";
                  //     }
                  //   });
                  // });
                  This.setState((state) => ({
                    downloadStatus: 1,
                    downloadtbody: res.data,
                    loadding: false,
                  }));
                  this.csvLink.current.link.click();
                } else {
                  if (res === 401) {
                  } else {
                    Modal.error({
                      title: "Failure",
                      content:
                        "Oops! something went wrong... Please try again.",
                    });
                  }
                }
              });
            }
          );

          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  };
  clearFilter = () => {
    try {
      this.setState(
        () => ({
          activePage: 1,
          totalItemsCount: 0,
           dateTo: moment().format("YYYY-MM-DD"),
           dateFrom: moment().subtract(7, "d").format("YYYY-MM-DD"),
        }),
        () => {
          var formFeilds = this.state.formData;
          formFeilds.map((feild, key) => {
            if (feild.name === "unit_id") {
              formFeilds[key]["value"] = null;
              formFeilds[key]["valid"] = false;
              formFeilds[key]["errors"] = [];
              formFeilds[key]["text"] = "Unit";
            } else if (feild.name === "billingFilters") {
              formFeilds[key]["value"] = null;
              formFeilds[key]["valid"] = false;
              formFeilds[key]["errors"] = [];
              formFeilds[key]["text"] = "Filters";
            } else if (feild.name === "floor_id") {
              formFeilds[key]["value"] = null;
              formFeilds[key]["valid"] = false;
              formFeilds[key]["errors"] = [];
              formFeilds[key]["text"] = "Floor";
            } else if (feild.name === "filters") {
              formFeilds[key]["value"] = null;
              formFeilds[key]["valid"] = false;
              formFeilds[key]["errors"] = [];
              formFeilds[key]["text"] = "Filters";
            } else if (feild.name === "doctor_id") {
              formFeilds[key]["value"] = null;
              formFeilds[key]["valid"] = false;
              formFeilds[key]["errors"] = [];
              formFeilds[key]["text"] = "Doctor";
            }
          });
          this.setState({ formData: formFeilds });
          this.loadPage();
        }
      );
    
    }
     catch (error) {
      console.log(error);
    }
  };
  handleKeydown = (event) => {
    if (event.key === 'Enter') { // Use 'key' instead of 'keys'
      this.searchClick();
    }
  }
  searchClick() {
    let { search_key } = this.state;
    this.setState({ activePage: 1 }, () => {

      this.loadPage(search_key);
    });
  }

  render() {
    let {
      totalItemsCount,
      formData,
      downloadtbody,
      downloadStatus,
      tableTitle,
      thead,
      data,
      tbody,
      filename,
      download_btn,
      select2,
      search,
      activePage,
      search_key,
      showAutoComplete,
      slug,
      handleKeydown,

    } = this.state;
    const selectedReport = this.state.selectedReport;
    return (
      <div className="DashboardView">
        <div className="clearfix">
          <div className="float-left pt-2 title-Text">{tableTitle}</div>
          {download_btn ? (
            downloadStatus && tbody != "" ? (
              <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                <button
                  className="btn btn-success text-capitalize"
                  onClick={() => {
                    this.downloadFile();
                  }}
                >
                  <img
                    src="/assets/images/icons/download1.png"
                    alt=""
                    className="pr-2"
                  />{" "}
                  <span> Download</span>
                </button>
                <CSVLink
                  data={downloadtbody}
                  headers={thead}
                  filename={filename}
                  className="hidden"
                  ref={this.csvLink}
                />
                <button
                  className="btn btn-light text-capitalize py-1 mr-3"
                  onClick={() => {
                   
                       
                    this.clearFilter();}}
                   
                  
                >
                  <UndoOutlined className="align-middle pr-2" />
                  <span> Clear</span>
                </button>
              </div>
            ) : (
              <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                <Button
                  className="btn btn-success-disabled text-capitalize float-left"
                  disabled
                >
                  <img
                    src="/assets/images/icons/download1.png"
                    alt=""
                    className="pr-2"
                  />
                  <span> Download</span>
                </Button>
                <button
                  className="btn btn-light text-capitalize py-1 mr-3 "
                  onClick={() => {
                    
                    this.clearFilter();
                    
                  }}
                >
                  <UndoOutlined type="reload" className="align-middle pr-2" />
                  <span> Clear</span>
                </button>
              </div>
            )
          ) : (
            <div className="mt-5" />
          )}
        </div>

        <Spin spinning={this.state.loadding}>
          {/* <div className=""> */}
          <div className="mr-3 clearfix">
            <div className="row">
              {formData &&
                formData.length > 0 &&
                formData.map((feild, key) => {
                  // eslint-disable-next-line no-lone-blocks
                  {
                    if (feild.element === "select2" && feild.visible) {
                      return (
                        <div className="col-3 pl-0">
                          {select2 ? (
                            <div
                              className={`${feild.className ? feild.className : "col"
                                } ${feild.name}`}
                              key={key}
                            >
                              <Select2
                                selectdata={feild}
                                // changedObj={this.state.changedObj}
                                {...this.props}
                                {...this.state}
                                // Queuedata={this.state.formData}
                                onselectChanges={this.handleChange.bind(this)}
                              />
                            </div>
                          ) : null}
                        </div>
                      );
                    }
                    if (feild.element === "input") {
                      return (
                        <div className="">
                          <div
                            className="d-flex mx-auto"
                            style={{ position: "absolute", left: "370px" }}
                          >
                            <div
                              className={`${feild.className ? feild.className : "col"
                                } ${feild.name}`}
                              key={key}
                            >
                              <Inputlayer
                                {...this.props}
                                {...this.state}
                                feildData={feild}
                                onInputChanges={this.handleChange.bind(this)}
                              />
                              <div class="input-group-append">
                                {/* <Button type="primary" onClick={this.search} loading={this.state.loadding}><img src="/assets/images/icons/search.png"></img></Button> */}
                                <button
                                  class="btn btn-primary btn-sm"
                                  onClick={this.search}
                                >
                                  <img src="/assets/images/icons/search.png" />
                                </button>
                              </div>
                            </div>
                          </div>

                        </div>
                      );
                    }
                    if (feild.element === "daterange") {
                      return (
                        <div className={`${feild.className ? feild.className : "col "}${feild.name}`} key={key}>
                    
                          <DateRange
                            Queuedata={formData}
                            selectdata={feild}
                            {...this.props}
                            {...this.state}
                            onselectChanges={(e) => {
                             this.setState({
                                dateFrom: e.value[0],
                                dateTo: e.value[1],
                              });
                            }}
                          />
                          <div className="input-group  , input-group-button">
                            <button className="btn btn-success btn-sm ml-4 p-1" onClick={this.dateRange}>
                              GO
                            </button>
                            {/* <div>
                              <div
                                style={{
                                  display: showAutoComplete ? 'block' : 'none',
                                  position: 'absolute',
                                  left: '70px',
                                  bottom: '31px',
                                }}
                              >
                                <AutoComplete
                                  style={{
                                    width: '400px',
                                    borderRadius: '10px',
                                    border: 'none',
                                    boxShadow: '0px 1px 8px rgba(23, 110, 222, 0.1)',
                                  }}
                                  placeholder="Search by Patient Name , UMR , Bill Number , Phone Number , Department "
                                  value={search_key}
                                  onChange={(value) => this.setState({ search_key: value })}
                                  onKeyDown={this.handleKeydown} 
                                />
                              </div>
                              {showAutoComplete && (
                                <div
                                  style={{
                                    position: 'relative',
                                    left: '490px',
                                    bottom: '32px',
                                    display: 'inline-block',
                                  }}
                                >
                                  <button

                                    className="btn btn-success btn-sm p-1"
                                    type="button"
                                    onClick={this.searchClick.bind(this)}
                                  >
                                    <img src="/assets/images/icons/search.png" alt="Search" />
                                  </button>
                                </div>
                              )}
                            </div> */}
                            <div>
                              
                            <div
                                style={{
                                  display: showAutoComplete ? 'block' : 'none',
                                  position: 'absolute',
                                  left: '70px',
                                  bottom: '20px',
                                }}
                              >
                                <AutoComplete
                                    style={{
                                      width: '400px', // Set your desired width for AutoComplete
                                      left: "10px",
                                      top: "20px",
                                      borderRadius: "10px",
                                      border: "none",
                                      boxShadow: "0px 1px 8px rgba(23, 110, 222, 0.1)",

                                    }}
                                    placeholder="Search by Patient Name , UMR , Bill Number , Phone Number , Department "
                                    value={search_key}
                                    onChange={(value) => this.setState({ search_key: value })}
                                    onInputKeyDown={this.handleKeydown}

                                  />
                              </div>
                              {showAutoComplete && (
                                <div
                                  style={{
                                    position: 'relative',
                                    left: '440px',
                                    top: "0px",
                                    display: 'inline-block',
                                  }}
                                >
                                  <button

                                    className="btn btn-success btn-sm p-1"
                                    type="button"
                                    onClick={this.searchClick.bind(this)}
                                  >
                                    <img src="/assets/images/icons/search.png" alt="Search" />
                                  </button>
                                </div>
                              )}
                            </div>


                          </div>
                          <div>

                          </div>
                        </div>
                      );
                    }


                  }
                })}
            </div>
          </div>

          <div className="card mt-2 mb-3 card-table">
            <div
              className="financial-table table-responsive sticky-header"
              id="table"
            >
              <table className="table table-hover table-bordered mb-0 bg-white">
                <thead>
                  <tr>
                    <td className="text-capitalize align-middle">S.No.</td>
                    {thead.map((head, key) => {
                      return (
                        head["label"]=="Vitals Time"?(<td className="text-capitalize align-middle" key={key}> <Tooltip title="Vitals Captured Time" color='#6c3964'>
                        
                            {head["label"]}
                        
                        </Tooltip></td>)
                        : head["label"]=="Waiting TAT 1"?(<td className="text-capitalize align-middle" key={key}> <Tooltip title="Arrival Time to Vitals Time" color='#6c3964'>
                        
                        {head["label"]}
                    
                    </Tooltip></td>)
                    :head["label"]=="Waiting TAT 2"?(<td className="text-capitalize align-middle" key={key}> <Tooltip title={
                      <div style={{ textAlign: 'center' }}>
                      Vitals Time to Checkin Time<br />
                      <span style={{ display: 'block' }}>or</span>
                      Arrival Time to Checkin Time
                    </div>
                } color='#6c3964'>
                        
                    {head["label"]}
                
                </Tooltip></td>)
                :head["label"]=="Procedural TAT"?(<td className="text-capitalize align-middle" key={key}> <Tooltip title=" Checkin Time to Checkout Time" color='#6c3964'>
                        
                {head["label"]}
            
            </Tooltip></td>)
            :
                        ( <td className="text-capitalize align-middle" key={key}>
                          {head["label"]}
                        </td>)
                       
                       
                      );
                    })}
                  </tr>
                </thead>
                {tbody != "" ? (
                  <tbody>
                    {tbody.map((body, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            {key +
                              1 +
                              (activePage > 1
                                ? 20 * (activePage > 2 ? activePage - 1 : 1)
                                : 0)}
                          </td>
                          {thead.map((head, Hkey) => {
                            if (head["key"] === "token_issue_date") {
                              return (
                                <td>
                                  {body["token_issue_date"]
                                    ? moment(body["token_issue_date"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "discharge_date") {
                              return (
                                <td>
                                  {body["discharge_date"]
                                    ? moment(body["discharge_date"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "created_at") {
                              return (
                                <td>
                                  {body["created_at"]
                                    ? moment(body["created_at"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "checkin_time") {
                              return (
                                <td>
                                  {body["checkin_time"]
                                    ? moment(body["checkin_time"]).format("LT")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "vitals_time") {
                              return (
                                <td>
                                  {body["vitals_time"]
                                    ? moment(body["vitals_time"]).format("LT")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "checkout_time") {
                              return (
                                <td>
                                  {body["checkout_time"]
                                    ? moment(body["checkout_time"]).format("LT")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "counselled_date") {
                              return (
                                <td>
                                  {body["counselled_date"]
                                    ? moment(body["counselled_date"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "date_of_counselling") {
                              return (
                                <td>
                                  {body["date_of_counselling"]
                                    ? moment(
                                      body["date_of_counselling"]
                                    ).format("DD-MM-YYYY HH:mm")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "recounselling_time") {
                              return (
                                <td>
                                  {body["recounselling_time"]
                                    ? moment(body["recounselling_time"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }

                            if (head["key"] === "previous_estimate_time") {
                              return (
                                <td>
                                  {body["previous_estimate_time"]
                                    ? moment(
                                      body["previous_estimate_time"]
                                    ).format("DD-MM-YYYY HH:mm")
                                    : "NA"}
                                </td>
                              );
                            }

                            if (head["key"] === "admitted_date") {
                              return (
                                <td>
                                  {body["admitted_date"]
                                    ? moment(body["admitted_date"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }

                            if (head["key"] === "admission_date") {
                              return (
                                <td>
                                  {body["admission_date"]
                                    ? moment(body["admission_date"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "eighty_percent_reached_time") {
                              return (
                                <td>
                                  {body["eighty_percent_reached_time"]
                                    ? moment(
                                      body["eighty_percent_reached_time"]
                                    ).format("DD-MM-YYYY HH:mm")
                                    : "NA"}
                                </td>
                              );
                            }

                            if (head["key"] === "discharge_date") {
                              return (
                                <td>
                                  {body["discharge_date"]
                                    ? moment(body["discharge_date"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "date") {
                              return (
                                <td>
                                  {body["date"]
                                    ? moment(body["date"]).format("DD-MM-YYYY")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "e_date_of_admission") {
                              return (
                                <td>
                                  {body["e_date_of_admission"]
                                    ? moment(
                                      body["e_date_of_admission"]
                                    ).format("DD-MM-YYYY")
                                    : "NA"}
                                </td>
                              );
                            }

                            if (head["key"] === "idle_start_time") {
                              return (
                                <td>
                                  {body["idle_start_time"]
                                    ? moment(body["idle_start_time"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "idle_end_time") {
                              return (
                                <td>
                                  {body["idle_end_time"]
                                    ? moment(body["idle_end_time"]).format(
                                      "DD-MM-YYYY HH:mm"
                                    )
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["type"] === "date") {
                              let new_date =
                                body[head["key"]] && body[head["key"]] !== ""
                                  ? body[head["key"]]
                                  : null;
                              return (
                                <td>
                                  {new_date
                                    ? moment(new_date).format("DD-MM-YYYY ")
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "avg_tat") {
                              return (
                                <td>
                                  {body["avg_tat"] && body["avg_tat"] !== ""
                                    ? Number.isInteger(body["avg_tat"])
                                      ? body["avg_tat"]
                                      : body["avg_tat"].toFixed(2)
                                    : "NA"}
                                </td>
                              );
                            }

                            return (
                              <td className="text-capitalize">
                                {body[head["key"]] !== ""
                                  ? body[head["key"]]
                                  : "NA"}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="13" className="text-center">
                        <img src="/assets/images/icons/no-data.svg" alt="" />
                        <p className="no-data mb-0">No Data</p>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          <div className="row justify-content-center align-item-center mx-0">
            <div className="col pagenation-col mb-3">
              {/* <Pagination

                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={totalItemsCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange.bind(this)}
                            /> */}

              <Pagination
                current={this.state.activePage}
                total={totalItemsCount}
                itemRender={this.itemRender.bind(this)}
                pageSize={20}
                onChange={this.handlePageChange.bind(this)}
              />
            </div>
          </div>
          
        </Spin>
      </div>
    );
  }
}

export default TAT_Report;
